// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3g7SH","noInteraction":"EventWrapper_noInteraction__25Yfn"};